// extracted by mini-css-extract-plugin
export var component = "Button-module--component--3dXao";
export var current = "Button-module--current--9yhgX";
export var icon = "Button-module--icon--jiSd2";
export var inert = "Button-module--inert--bxfOl";
export var label = "Button-module--label--7045c";